"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Flex = _interopRequireDefault(require("../../Flex"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var _useTheme2 = _interopRequireDefault(require("../../styles/useTheme"));

var _Decoration = _interopRequireDefault(require("./Decoration"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme2["default"])(),
      spacing = _useTheme.spacing;

  return {
    root: {
      position: 'relative'
    },
    first: {
      position: 'absolute',
      top: spacing(-2.5),
      left: 0,
      transform: "translateX(-".concat(spacing(2.5), ")")
    },
    second: {
      position: 'absolute',
      bottom: spacing(-2.5),
      right: 0,
      transform: "translateX(".concat(spacing(2.5), ") rotateZ(90deg) rotateY(180deg)")
    }
  };
};

__signature__(useStyles, "useTheme{{ spacing }}", function () {
  return [_useTheme2["default"]];
});

var CheeryContainer = function CheeryContainer(props) {
  var _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      children = props.children,
      other = (0, _objectWithoutProperties2["default"])(props, ["color", "children"]);
  var classes = useStyles();
  return (0, _core.jsx)(_Flex["default"], (0, _extends2["default"])({
    flexDirection: "column",
    alignItems: "stretch",
    css: classes.root
  }, other), (0, _core.jsx)(_Icon["default"], {
    css: classes.first,
    as: _Decoration["default"],
    color: color,
    size: 3.5
  }), children, (0, _core.jsx)(_Icon["default"], {
    css: classes.second,
    as: _Decoration["default"],
    color: color,
    size: 3.5
  }));
};

__signature__(CheeryContainer, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = CheeryContainer;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/Cta/CheeryContainer/index.tsx");
  reactHotLoader.register(CheeryContainer, "CheeryContainer", "/builds/bA1zbJom/0/gojob/ui-bits/src/Cta/CheeryContainer/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Cta/CheeryContainer/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();